import { API } from "../../../beans";

export enum WotdPresetActionEnum {
  REQUEST = "app/WOTDPRESET/REQUEST",
  SUCCESS = "app/WOTDPRESET/SUCCESS",
  FAIL = "app/WOTDPRESET/FAIL",
}

export interface IWotdPresetRequest {
  type: WotdPresetActionEnum.REQUEST;
  hash?: string;
}
export interface IWotdPresetSuccess {
  type: WotdPresetActionEnum.SUCCESS;
  data: API.WotdPreset;
}
export interface IWotdPresetFail {
  type: WotdPresetActionEnum.FAIL;
  err: Error;
}

export type WotdPresetAction =
  | IWotdPresetRequest
  | IWotdPresetSuccess
  | IWotdPresetFail;

export function wotdPresetRequest(hash?: string): IWotdPresetRequest {
  return {
    type: WotdPresetActionEnum.REQUEST,
    hash,
  };
}
export function wotdPresetSuccess(data: API.WotdPreset): IWotdPresetSuccess {
  return {
    type: WotdPresetActionEnum.SUCCESS,
    data,
  };
}
export function wotdPresetFail(err: Error): IWotdPresetFail {
  return {
    type: WotdPresetActionEnum.FAIL,
    err,
  };
}
